<section id="hero">
  <swiper
    #swiper
    
    [slidesPerView]="1"
    [centeredSlides]="true"
    [loop]="true"
    [navigation]="{
      prevEl: '.heroSlidePrev',
      nextEl: '.heroSlideNext'
    }"
  >
    <ng-template swiperSlide *ngFor="let slide of slidesStore; index as i">
      <img
        class="nomobile"
        [src]="slide.src"
        [alt]="slide.alt"
        [title]="slide.title"
      />
      <div
        class="mobile bgimg"
        [ngStyle]="{ 'background-image': 'url(' + slide.mobilesrc + ')' }"
      ></div>
      <div class="carouselCTA nomobile">
        <a
          href="{{ slide.CTALink }}"
          class="button primary old scrolly"
          [class]="slide.Theme"
          >{{ slide.CTALabelDesktop }}</a
        >
      </div>
      <div class="carouselCTA mobile">
        <a
          href="{{ slide.CTALink }}"
          class="button primary old scrolly"
          [class]="slide.Theme"
          >{{ slide.CTALabel }}</a
        >
      </div>
      <div class="carouselCTA2" [hidden]="!slide.CTALabel2">
        <a href="{{ slide.CTALink2 }}" class="button primary old scrolly">{{
          slide.CTALabel2
        }}</a>
      </div>
    </ng-template>
  </swiper>
<!--
  <swiper
    #swiper
    class="nomobile"
    [slidesPerView]="1"
    [centeredSlides]="true"
    [loop]="true"
    [navigation]="{
      prevEl: '.heroSlidePrev',
      nextEl: '.heroSlideNext'
    }"
  >
    <ng-template
      swiperSlide
      *ngFor="let slide of slidesStoreDesktop; index as i"
    >
      <img
        class="nomobile"
        [src]="slide.src"
        [alt]="slide.alt"
        [title]="slide.title"
      />
      <div
        class="mobile bgimg"
        [ngStyle]="{ 'background-image': 'url(' + slide.mobilesrc + ')' }"
      ></div>

      <div *ngIf="slide.id != '002'" class="carouselCTA nomobile">
        <a
          href="{{ slide.CTALink }}"
          class="button primary old scrolly"
          [class]="slide.Theme"
          >{{ slide.CTALabelDesktop }}</a
        >
      </div>

      <div class="futureProductions nomobile" *ngIf="slide.id == '002'">
        <ul class="flex-container wrap">
          <li class="flex-item">
            <img src="./assets/images/Samuel-Mudian_future.jpg" />
            <a
              href="#two"
              class="button primary scrolly dorotheeBtn"
              >Samuel Mudian</a
            >
          </li>
          <li class="flex-item">
            <img src="./assets/images/john_goldframe.png" />
            <a
              href="#five"
              class="button primary scrolly johnBtn"
              >John</a
            >
          </li>
          <li class="flex-item">
            <img src="./assets/images/samuel2_front_goldframe.jpg" />
            <a
              href="#four"
              class="button primary scrolly linleyBtn"
              >Samuel Linley</a
            >
          </li>
          <li class="flex-item">
            <img src="./assets/images/charles-caesar_blackframe.jpg" />
            <a
              href="#three"
              class="button primary scrolly charlesBtn"
              >Charles Caesar</a
            >
          </li>
          <li class="flex-item">
            <img src="./assets/images/thomas_blackframe.png" />
            <a
              href="#six"
              class="button primary scrolly thomasBtn"
              >Thomas</a
            >
          </li>
        </ul>
      </div>
    </ng-template>
  </swiper>
-->
  <div class="heroSlideAction">
    <a class="heroSlidePrev"><img src="./assets/images/prev.svg" /></a
    ><a class="heroSlideNext"><img src="./assets/images/next.svg" /></a>
  </div>
</section>

<!-- Banner -->
<!--
  <section id="banner">
    <div class="content">
      <header>
        <h2>Five ASide Theatre CIC</h2>
        <p>
          Let’s Play The Play, <br />
          Truth As A Game.
        </p>
      </header>
      <span class="image"
        ><img src="./assets/images/transparent background_Five.png" alt=""
      /></span>
    </div>
    <a href="#one" class="goto-next home scrolly">Next</a>
  </section>
  -->

<!-- One -->
<section id="one" class="spotlight styleDorothee bottom">
  <span class="image fit main"
    ><img src="./assets/images/dorothee2.jpg" alt=""
  /></span>
  <div class="content">
    <div class="container DOROTHEE">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <span class="image fit mainx nomobile">
              <img src="./assets/images/dorothee2.jpg" />
            </span>
            <audio style="width: 100%" controls>
              <source
                src="../../../assets/audio/Dorothee-Performance -V8-K9beetz.mp3"
                type="audio/mpeg"
              />
            </audio>
          </header>
        </div>
        <div class="col-8 col-12-medium">
          <div class="info">
            <h1 class="old">Dorothee</h1>
            <h2 class="old">in the 18th century</h2>
            <h3 class="old">
              I got a Story to tell <span class="defaultfont">...</span>from
              time
            </h3>
            <p class="old">
              The Cryer ArtS Centre<br />
              39 CarShalton SM5 3BB<br />
              <span class="date">23rd October 7pm</span><br />
            </p>
            <p class="old">
              £10 ticketS available from <br />
              <a
                href="http://www.ticketsource.co.uk/whats-on/carshalton/cryerarts-theatre/dorothee-in-the-18th-century"
                target="_blank"
                >TICKETSOURCE</a
              >
            </p>
            <p>
              <span class="image fit mainx">
                <img src="./assets/images/dorothee_flyer_bank_logos2.png" />
              </span>
            </p>

            <span class="image fit mainx mobile">
              <img src="./assets/images/dorothee2.jpg" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#two" class="goto-next scrolly">Next</a>
</section>
<!-- Samuel -->
<section id="two" class="spotlight styleSamuel bottom">
  <span class="image fit main"
    ><img src="./assets/images/Samuel-Mudian.jpg"
  /></span>
  <div class="content">
    <div class="container SAMUEL">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <span class="image fit mainx nomobile">
              <img src="./assets/images/Samuel-Mudian.jpg" />
            </span>
            <audio style="width: 100%" controls>
              <source
                src="../../../assets/audio/Samuel-Mudian-MASTERED_01.mp3"
                type="audio/mpeg"
              />
            </audio>
          </header>
        </div>
        <div class="col-8 col-12-medium">
          <div class="info">
            <h2 class="old">ReviSualiSing Samuel Mudian</h2>
            <div class="blurb">
              <p class="old">
                <span>ViSualiSation:</span> written by Deborah Bell<br />

                <span>Voice Actor:</span> Delon JeSSop<br />

                <span>Music compoSer:</span> Ebu Blakitude <br />

                <span>Photographer:</span> K. DaviS<br />

                <span>CoStumeS</span> courteSy of Lantern ArtS Centre<br />

                <span>Taken from the production</span> Dorothee in the 18th
                century I got a Story to tell….from time. <br />
                Produced by Sutton African Caribbean Cultural OrganiSation and
                Five ASide Theatre CIC <br />

                <!--<span>Full Booking details</span> TICKETSOURCE.CO.UK<br/>-->
                <span>Director</span> Mic Lord<br />

                Funded by
              </p>
            </div>
            <p>
              <span class="image fit mainx">
                <img src="./assets/images/dorothee_flyer_bank_logos2.png" />
              </span>
            </p>

            <span class="image fit mainx mobile">
              <img src="./assets/images/Samuel-Mudian.jpg" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#three" class="goto-next scrolly">Next</a>
</section>
<!-- Charles -->
<section id="three" class="spotlight styleCharles bottom">
  <span class="image fit main"
    ><img src="./assets/images/charles-caesar.jpg" alt=""
  /></span>
  <div class="content">
    <div class="container CHARLES">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <span class="image fit mainx nomobile">
              <img src="./assets/images/charles-caesar.jpg" alt="" />
            </span>
            <!--
            <audio style="width: 100%" controls>
              <source
                src="../../../assets/audio/Samuel Mudian Audio Drama-30sec.mp3"
                type="audio/mpeg"
              />
            </audio>
            -->
          </header>
        </div>
        <div class="col-8 col-12-medium">
          <div class="info">
            <h2 class="old">CharleS CaeSar ViSualiSed</h2>
            <div class="blurb">
              <p class="old">
                <strong>ViSualiSation written by</strong> LiSa Kim MacLaren<br />
                <strong>ViSion</strong> J Allman <br />
                <strong>Photographer</strong> K DaviS<br />
                <strong>CoStumeS courteSy of</strong> Lantern ArtS Centre<br />
                Taken from the production Dorothee in the 18th century I got a
                Story to tell...from time.<br/> 
                <strong>Produced by</strong> SACCO and Five ASide Theatre CIC<br />
                <strong>Director</strong> Mic Lord<br />
              </p>
            </div>
            <p>
              <span class="image fit mainx">
                <img src="./assets/images/dorothee_flyer_bank_logos2.png" />
              </span>
            </p>

            <span class="image fit mainx mobile">
              <img src="./assets/images/charles-caesar.jpg" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#four" class="goto-next scrolly">Next</a>
</section>
<!-- Samuel Linley -->
<section id="four" class="spotlight styleSamuelLinley bottom">
  <span class="image fit main"
    ><img src="./assets/images/abi-young-samuel-linley.jpg" alt=""
  /></span>
  <div class="content">
    <div class="container SAMUELLINLEY">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <span class="image fit mainx nomobile">
              <img src="./assets/images/samuel2_front.jpg" alt="" />
            </span>

            <audio style="width: 100%" controls>
              <source
                src="../../../assets/audio/Abi-Audio-Drama_.mp3"
                type="audio/mpeg"
              />
            </audio>
          </header>
        </div>
        <div class="col-8 col-12-medium">
          <div class="info">
            <h2 class="old">ReviSualiSing Samuel Linley</h2>
            <div class="blurb">
              <p class="old">
                <strong>ViSualiSation written by</strong> Beverley Dixon<br />
                <strong>Voice Actor</strong> Simone MacIntyre<br />
                <strong>MuSic compoSer</strong> K9beatz<br />
                <strong>Photographer</strong> K DaviS<br />
                <strong>CoStumeS courteSy of</strong> Lantern ArtS Centre<br />
                <strong
                  >Taken from the production Dorothee in the 18th century I got
                  a Story to tell...from time.</strong
                ><br />
                <!--<strong>Full booking details</strong>
                TICKETSOURCE.CO.UK<br />-->
                <strong>Director</strong> Mic Lord<br />
                <strong>Produced by</strong> SACCO and Five ASide Theatre CIC<br />
              </p>
            </div>
            <p>
              <span class="image fit mainx">
                <img src="./assets/images/dorothee_flyer_bank_logos2.png" />
              </span>
            </p>

            <span class="image fit mainx mobile">
              <img src="./assets/images/samuel2_front.jpg" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#five" class="goto-next scrolly">Next</a>
</section>
<!-- John -->
<section id="five" class="spotlight styleJohn bottom">
  <span class="image fit main"
    ><img src="./assets/images/john.jpg" alt=""
  /></span>
  <div class="content">
    <div class="container JOHN">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <span class="image fit mainx nomobile">
              <img src="./assets/images/john.jpg" alt="" />
            </span>
            <audio style="width: 100%" controls>
              <source
                src="../../../assets/audio/John Audio Drama_01.mp3"
                type="audio/mpeg"
              />
            </audio>
          </header>
        </div>
        <div class="col-8 col-12-medium">
          <div class="info">
            <h2 class="old">ReviSualiSing John</h2>
            <div class="blurb">
              <p class="old">
                <strong>ViSualiSation written by</strong> Michael Norman Smith<br />
                <strong>Voice Actor</strong> Delon JeSSop<br />
                <strong>MuSic compoSer</strong> Ebu Blakitude<br />
                <strong>ViSion</strong> R Dauda<br />
                <strong>CostumeS courteSy of</strong> Lantern ArtS Centre<br />
                <strong>Taken from the production</strong> Dorothee in the 18th
                century I got a Story to tell...from time.<br />
                <!--<strong>Full booking detailS</strong>
                www.TICKETSOURCE.CO.UK<br />-->
                <strong>Director</strong> Mic Lord<br />
                <strong>Produced by</strong> SACCO and Five ASide Theatre CIC<br />
              </p>
            </div>
            <p>
              <span class="image fit mainx">
                <img src="./assets/images/dorothee_flyer_bank_logos2.png" />
              </span>
            </p>

            <span class="image fit mainx mobile">
              <img src="./assets/images/john.jpg" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#six" class="goto-next scrolly">Next</a>
</section>
<!-- Thomas -->
<section id="six" class="spotlight styleThomas bottom">
  <span class="image fit main"
    ><img src="./assets/images/thomas.jpg" alt=""
  /></span>
  <div class="content">
    <div class="container THOMAS">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <span class="image fit mainx nomobile">
              <img src="./assets/images/thomas.jpg" alt="" />
            </span>
            <!--
              <audio style="width: 100%" controls>
                <source
                  src="../../../assets/audio/Samuel Mudian Audio Drama-30sec.mp3"
                  type="audio/mpeg"
                />
              </audio>
            -->
          </header>
        </div>
        <div class="col-8 col-12-medium">
          <div class="info">
            <h2 class="old">ThomaS ViSualiSed</h2>
            <div class="blurb">
              <p class="old">
                <strong>ViSualiSation written by</strong> Saadia Stuart<br />
                <strong>Vision</strong> J. Plummer<br />
                <strong>Photographer</strong> K DaviS<br />
                <strong>CostumeS courteSy of</strong> Lantern ArtS Centre<br />
                <strong>Taken from the production</strong> Dorothee in the 18th
                century I got a Story to tell...from time.<br />
                <!--<strong>Full booking detailS</strong>
                www.ticketSource.co.uk<br />-->
                <strong>Director</strong> Mic Lord<br />
                <strong>Produced by</strong> SACCO and Five ASide Theatre CIC<br />
              </p>
            </div>
            <p>
              <span class="image fit mainx">
                <img src="./assets/images/dorothee_flyer_bank_logos2.png" />
              </span>
            </p>

            <span class="image fit mainx mobile">
              <img src="./assets/images/thomas.jpg" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#getdirections" class="goto-next scrolly">Next</a>
</section>
<!-- Dorothee Visualised -->
<!--
<section id="seven" class="spotlight styleDorotheeVis bottom">
  <span class="image fit main"
    ><img src="./assets/images/dorotheevis.jpg" alt=""
  /></span>
  <div class="content">
    <div class="container DOROTHEEVIS">
      <div class="row">
        <div class="col-4 col-12-medium">
          <header>
            <span class="image fit mainx nomobile">
              <img src="./assets/images/dorotheevis.jpg" alt="" />
            </span>

              <audio style="width: 100%" controls>
                <source
                  src="../../../assets/audio/Samuel Mudian Audio Drama-30sec.mp3"
                  type="audio/mpeg"
                />
              </audio>
            
          </header>
        </div>
        <div class="col-8 col-12-medium">
          <div class="info">
            <h2 class="old">Dorothee ViSualiSed</h2>
            <div class="blurb">
              <p class="old">
                <strong>ViSualiSation written by</strong> Suzi Davis<br />
                <strong>Voice Actor</strong> Simone MacIntyre<br />
                <strong>MuSic compoSer</strong> K9beatz<br />
                <strong>ViSion</strong> M. Nelson<br />
                <strong>Photographer</strong> K DaviS<br />
                <strong>CoStumeS courteSy of</strong> Lantern ArtS Centre<br />
                <strong
                  >Taken from the production Dorothee in the 18th century I got
                  a Story to tell...from time.</strong
                ><br />
                <strong>Full booking details</strong>
                www.ticketsource.co.uk<br />
                <strong>Director</strong> Mic Lord<br />
                <strong>Produced by</strong> SACCO and Five ASide Theatre CIC<br />
              </p>
            </div>
            <p>
              <span class="image fit mainx">
                <img src="./assets/images/dorothee_flyer_bank_logos2.png" />
              </span>
            </p>

            <span class="image fit mainx mobile">
              <img src="./assets/images/dorotheevis.jpg" alt="" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a href="#getdirections" class="goto-next scrolly">Next</a>
</section>
-->
<!-- Get Directions -->
<section id="getdirections" class="wrapper style1 special fade-up">
  <div class="container">
    <header class="major">
      <h2>Map and Directions</h2>
      <p>
        Map and directions Map and directions Map and directions Map and
        directions Map and directions
      </p>
    </header>
    <div class="box alt">
      <div class="row gtr-uniform">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2491.0227407792277!2d-0.16174408407584484!3d51.365878628861445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487607060b7edec3%3A0x598aa5bde6fbf6bf!2sThe%20CryerArts%20Centre!5e0!3m2!1sen!2suk!4v1633118428674!5m2!1sen!2suk"
          width="100%"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
    <footer class="major">
      <ul class="actions special">
        <li>
          <a href="geo:51.394362,-0.225872&z=15&t=m&hl=en&gl=GB" class="button"
            >Open map for directions</a
          >
        </li>
      </ul>
    </footer>
  </div>
</section>
